module.exports = __webpack_public_path__ + "img/content_bg1@3x.ca3da83f.png";